import { MODE_DEV, MODE_PROD } from 'root/settings'
import { getSchema } from '../utils'

export const USERS_COURIER = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            createdAt: 'createdAt',
            email: 'email',
            phoneNumber: 'phoneNumber',
            profilePictureURL: 'profilePictureURL',
            isDisabled: 'isDisabled'
        }),
        [MODE_PROD]: Object.freeze({
            createdAt: 'ca',
            email: 'e',
            phoneNumber: 'pn',
            profilePictureURL: 'ppu',
            isDisabled: 'isd'
        })
    })
})()
